export function exportWishlistItemsToCsv(items, isOwner, filename, options = {}) {
  if (!items) return;

  const {
    includePurchased = false,
    includeRank = false,
    // "all" shows the purchased/estimated pair; any other value shows a single
    // Total Cost ("purchased"/"not_purchased" for a filtered Claimed Items view,
    // "total" for a plain wishlist where nothing is filtered).
    totalsMode = "all",
    purchasedTotal = 0,
    estimatedTotal = 0,
    totalCost = 0
  } = options;

  const headers = [];

  // Only a single ranked wishlist has a meaningful rank; the cross-list Claimed
  // Items export opts out and keeps its original columns.
  if (includeRank) {
    headers.push("Rank");
  }

  headers.push(
    "Item",
    "URL",
    "List Name",
    "Price",
    "Created On",
    "Claimed",
    "Claimed By",
    "Claimed On"
  );

  if (includePurchased) {
    headers.push("Purchased", "Purchased On");
  }

  headers.push("Recipient");

  const rows = (items || []).map((item, index) => {
    const baseRow = [
      item.item_text || "",
      item.url || "",
      item.names?.name || "",
      item.price !== null && item.price !== undefined
        ? `$${Number(item.price).toFixed(2)}`
        : "",
      item.created_at
        ? new Date(item.created_at).toLocaleString("en-US", {
            timeZone: "America/New_York"
          })
        : "",
      isOwner ? "" : (item.claimed_by ? "Yes" : "No"),
      !isOwner && item.users?.display_name ? item.users.display_name : "",
      item.claimed_at
        ? new Date(item.claimed_at).toLocaleString("en-US", {
            timeZone: "America/New_York"
          })
        : ""
    ];

    if (includeRank) {
      // Same rule as the on-screen ribbon: rank is the row's position, not a
      // stored value, so it is always contiguous from 1.
      baseRow.unshift(index + 1);
    }

    if (includePurchased) {
      baseRow.push(
        item.purchased_at ? "Yes" : "No",
        item.purchased_at
          ? new Date(item.purchased_at).toLocaleString("en-US", {
              timeZone: "America/New_York"
            })
          : ""
      );
    }

    baseRow.push(item.surprise_recipient_label || "");

    return baseRow;
  });

  // Totals row(s) that mirror the UI logic (CSV can't color text).
  // Columns are located by header name rather than hardcoded index, so adding or
  // reordering a column can't silently shift the totals under the wrong heading.
  const totalsRow = new Array(headers.length).fill("");
  const labelCol = headers.indexOf("Item");
  const priceCol = headers.indexOf("Price");

  if (totalsMode === "all") {
    totalsRow[labelCol] = "Purchased / Estimated Total";
    totalsRow[priceCol] = `$${Number(purchasedTotal).toFixed(2)} / $${Number(
      estimatedTotal
    ).toFixed(2)}`;
  } else {
    totalsRow[labelCol] = "Total Cost";
    totalsRow[priceCol] = `$${Number(totalCost).toFixed(2)}`;
  }

  rows.push(totalsRow);

  const csv = [headers, ...rows]
    .map((row) => row.map((v) => `"${String(v).replace(/"/g, '""')}"`).join(","))
    .join("\n");

  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = filename || "export.csv";
  link.click();
}
